import { Box } from '@givebutter/primitives/box';
import * as LetterDownload from 'assets/js/pages/engage/letters/LetterDownload';
import { useCurrentLetter } from 'assets/js/pages/engage/letters/useCurrentLetter';

const LetterDownloads = () => {
    const { data: letter } = useCurrentLetter();

    if (!letter || letter.status === 'failed') {
        return null;
    }

    return (
        <div className={'flex flex-col gap-2'}>
            <div className={'flex'}>
                <p className={'text-lg font-medium'}>Downloads</p>
            </div>

            <Box className={'bg-gray-25 divide-y divide-gray-100'}>
                <LetterDownload.Root download={letter.downloads.zip}>
                    <LetterDownload.Container>
                        <LetterDownload.DescriptionContainer>
                            <LetterDownload.Title>
                                Letters, envelopes, and labels
                            </LetterDownload.Title>
                            <LetterDownload.Description>
                                Compressed file containing all PDF letters
                            </LetterDownload.Description>
                        </LetterDownload.DescriptionContainer>
                        <LetterDownload.Status type={'zip'} />
                    </LetterDownload.Container>
                </LetterDownload.Root>
            </Box>
        </div>
    );
};

export { LetterDownloads };
